import HeadlineTicker from './HeadlineTicker';
import type { HeadlineToken } from './HeadlineItem';

interface HeaderProps {
  isSearchMode?: boolean;
  onReset?: () => void;
  onSearchToken?: (address: string) => void;
  headlineTokens?: HeadlineToken[];
}

export default function Header({ isSearchMode, onReset, onSearchToken, headlineTokens }: HeaderProps) {
  const scrollToTop = () => {
    const startPosition = window.pageYOffset;
    const duration = 400; // 400ms (빠른 스크롤)
    const startTime = performance.now();

    const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

    const animateScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = easeOutCubic(progress);

      window.scrollTo(0, startPosition * (1 - easeProgress));

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  const handleLogoClick = () => {
    onReset?.();
    scrollToTop();
  };

  return (
    <header className={`header${isSearchMode ? ' header--search-mode' : ''}`}>
      <div className="header-content">
        <img
          src="/static/logo_elon_circle.png"
          alt="Logo"
          className="header-logo"
          onClick={handleLogoClick}
        />
        <h1 className="header-brand" onClick={handleLogoClick}>
          MONEYBALL
        </h1>
        <HeadlineTicker tokens={headlineTokens} onTokenClick={onSearchToken} />
      </div>
    </header>
  );
}
